import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/login';
import { MainLayout } from './components/layout/MainLayout.tsx';
import { HomePage } from './pages/home.tsx';
import { AuthLayout } from './components/layout/AuthLayout.tsx';
import { AuthProvider } from './components/auth/AuthContext.tsx';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SettingPage } from './pages/setting.tsx';
import { SittingsPage } from './pages/sittings.tsx';
import { SittingDetailPage } from './pages/sittings/detail.tsx';
import { SittingReportPage } from './pages/sittings/repot.tsx';
import { SettingProfilePage } from './pages/settings/profile.tsx';
import { SignupPage } from './pages/signup.tsx';
import { ResetPasswordPage } from './pages/reset-password.tsx';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#faad14',
            colorInfo: '#faad14',
            colorWarning: '#fadb14',
            borderRadius: 4,
            wireframe: false,
          },
        }}
      >
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="auth" element={<AuthLayout />}>
                <Route path="sign-in" element={<LoginPage />} />
                <Route path="sign-up" element={<SignupPage />} />
                <Route path="reset" element={<ResetPasswordPage />} />
              </Route>

              <Route path="/" element={<MainLayout />}>
                <Route index element={<HomePage />} />
                <Route path="sittings" element={<SittingsPage />} />
                <Route path="sittings/:id" element={<SittingDetailPage />} />
                <Route path="sittings/:id/report" element={<SittingReportPage />} />
                <Route path="settings" element={<SettingPage />} />
                <Route path="settings/profile" element={<SettingProfilePage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
